import { KbColor } from './kb-color';
import { KbQuaternion } from './kb-quaternion';
import { IKbVectorLike, KbVector } from './kb-vector';

export function isKbVector(object: any): object is KbVector {
    return object && object.x !== undefined && object.y !== undefined && object.z !== undefined;
}

export function isKbColor(object: any): object is KbColor {
    return (
        object && object.r !== undefined && object.g !== undefined && object.b !== undefined && object.a !== undefined
    );
}

export function isKbQuaternion(object: any): object is KbQuaternion {
    return (
        object && object.x !== undefined && object.y !== undefined && object.z !== undefined && object.w !== undefined
    );
}

export function isPrimitive(object: any) {
    return isKbVector(object) || isKbColor(object) || isKbQuaternion(object);
}

export interface IBoundingBox {
    min: IKbVectorLike;
    max: IKbVectorLike;
    center: IKbVectorLike;
}
